export class User {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    first_name!: string;
    last_name!: string;
    email!: string;
    mobile_phone!: string;
    type!: string;
    notes!: string;
    picture!: string;
}
